import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Link } from 'react-router-dom';
import { Validate } from '../../../other';
import { soporteObtenerPreguntasKnowledgeBase } from '../../../store/actions';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Typography,
  withStyles,
  LinearProgress,
} from '@material-ui/core';
import {
  AutosuggestUI,
  ButtonUI,
  AlertUI,
  CardModuleUI,
  ToggleUI,
  IconUI,
} from '../../common';
import { WrapperLayout } from '../../../layouts/WrapperLayout';

const SubcategoriasListItem = (props) => {
  let { category, classes } = props;
  const renderizarSubcategorias = () => {
    if (category && category.subcategories.length > 0) {
      return category.subcategories.map((subcategory, index) => {
        return (
          <ListItem
            divider={index < category.subcategories.length - 1}
            key={subcategory.slug}
            classes={{ root: classes.list_item }}
          >
            <Link
              to={{
                pathname: '/soporte/' + category.slug + '/' + subcategory.slug,
              }}
              style={{ width: '100%' }}
            >
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    spacing={8}
                  >
                    <Grid item xs={9}>
                      <Grid container alignItems="center" spacing={8}>
                        <ToggleUI show={subcategory.icon ? true : false}>
                          <Grid item>
                            <ListItemAvatar>
                              <Avatar className={classes.avatar}>
                                <IconUI
                                  name={subcategory.icon}
                                  style={{
                                    fontSize: '1rem',
                                    textAlign: 'center',
                                  }}
                                />
                              </Avatar>
                            </ListItemAvatar>
                          </Grid>
                        </ToggleUI>
                        <Grid item>
                          <Typography className={classes.list_item_title}>
                            {subcategory.title}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <IconButton aria-label="Aceptar">
                        <Icon
                          style={{
                            fontSize: '1.5rem',
                            textAlign: 'center',
                          }}
                        >
                          navigate_next
                        </Icon>
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Link>
          </ListItem>
        );
      });
    } else {
      return (
        <ListItem>
          <ListItemText primary="No hay preguntas disponibles en esta sección" />
        </ListItem>
      );
    }
  };

  return (
    <List classes={{ root: classes.list }}>{renderizarSubcategorias()}</List>
  );
};

class SubcategoriasList_ extends Component {
  state = {
    loading: {
      subcategories: true,
      error: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
    category: [],
    feed: [],
    feed_input_value: '',
    selected_option: '',
    articles_arr: [],
  };

  //autosuggest
  debounceMethod = null;

  componentDidMount() {
    let category_slug = this.props.location.pathname.split('/');
    category_slug = category_slug[category_slug.length - 1];

    this.props.soporteObtenerPreguntasKnowledgeBase((err, resp) => {
      let category_arr = resp.data.knowledge_base_data.filter(
        (category) => category.slug === category_slug
      );

      this.setState(
        {
          category: category_arr,
          loading: {
            ...this.state.loading,
            subcategories: false,
            error: err ? true : false,
          },
        },
        () => {
          let articles_arr = [];
          resp.data.knowledge_base_data.forEach((category) => {
            category.subcategories.forEach((subcategory) => {
              subcategory.articles.forEach((article) => {
                articles_arr = [
                  ...articles_arr,
                  {
                    ...article,
                    subcategory: subcategory.title,
                    subcategory_slug: subcategory.slug,
                    category: category.title,
                    category_slug: category.slug,
                    rank: 0,
                  },
                ];
              });
            });
          });
          this.setState({ articles_arr: articles_arr });
        }
      );
    });

    this.debounceMethod = debounce(this.handleSuggestionFetchData, 200);
  }

  normalizeText = (value) => {
    value = value.toLowerCase();
    value = value.replaceAll('á', 'a');
    value = value.replaceAll('é', 'e');
    value = value.replaceAll('í', 'i');
    value = value.replaceAll('ó', 'o');
    value = value.replaceAll('ú', 'u');
    value = value.replaceAll('ñ', 'n');

    return value;
  };

  handleSuggestionFetchData = (value) => {
    if (value.length > 1) {
      let words = value.split(' ');

      let array = [...this.state.articles_arr];
      words.forEach((word) => {
        word = this.normalizeText(word);
        array.forEach((article) => {
          let title_art = this.normalizeText(article.title);
          let category = this.normalizeText(article.category);
          let subcategory = this.normalizeText(article.subcategory);
          let content;
          if (article.type === 0) {
            content = this.normalizeText(article.content);
            if (content.includes(word)) article.rank = article.rank + 1;
          }

          if (title_art.includes(word)) article.rank = article.rank + 1;
          if (category.includes(word)) article.rank = article.rank + 1;
          if (subcategory.includes(word)) article.rank = article.rank + 1;
        });
      });

      array.sort((a, b) => {
        return b.rank - a.rank;
      });

      let feed = array.filter((element) => element.rank > 0);
      feed = feed.slice(0, 15);

      this.setState({ feed: feed });
    }
  };

  handleChangeFilter = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [aditional]: {
        ...this.state[aditional],
        [name]: {
          ...this.state[aditional][name],
          value: value,
        },
      },
    });
  };

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleOnSuggestionSelected = (selected_suggestion) => {
    this.setState(
      {
        selected_option: selected_suggestion,
        feed_input_value: '',
      },
      () => {
        if (selected_suggestion.type === 0) {
          this.props.history.push(
            `/soporte/${selected_suggestion.category_slug}/${selected_suggestion.subcategory_slug}/${selected_suggestion.slug}`
          );
        } else {
          window.open(selected_suggestion.content, '_blank');
        }
      }
    );
  };

  handleSuggestionsFetchRequested = ({ value }) => this.debounceMethod(value);

  handleSuggestionsClearRequested = () => {
    let articles = [...this.state.articles_arr];
    articles.forEach((article) => {
      article.rank = 0;
    });

    this.setState({
      feed: [],
      articles_arr: articles,
    });
  };

  handleSuggestionsChangeSelected = (e, { newValue }) =>
    this.setState({ feed_input_value: newValue });

  render() {
    let classes = this.props.classes;

    let category = this.state.category;

    return (
      <WrapperLayout
        loading={this.state.loading.subcategories}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Grid container spacing={16} alignItems="center">
              <Grid item>
                <ButtonUI
                  label={<Icon>keyboard_arrow_left</Icon>}
                  type="callf"
                  onClickFunc={() => window.history.go(-1)}
                />
              </Grid>
              <Grid item>
                <Typography className={classes.title_back}>
                  Volver a preguntas frecuentes
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              Acá podés encontrar lo que necesitás
            </Typography>
            <CardModuleUI>
              <Grid container justify="space-between" spacing={24}>
                <Grid item xs={12}>
                  <AutosuggestUI
                    suggestions={this.state.feed}
                    input_value={this.state.feed_input_value}
                    suggestion_selected={this.state.selected_option}
                    suggestion_index={'title'}
                    label={'Buscar'}
                    placeholder={'Tengo una consulta sobre...'}
                    handleOnSuggestionSelected={this.handleOnSuggestionSelected}
                    handleSuggestionsFetchRequested={
                      this.handleSuggestionsFetchRequested
                    }
                    handleSuggestionsClearRequested={
                      this.handleSuggestionsClearRequested
                    }
                    handleSuggestionsChangeSelected={
                      this.handleSuggestionsChangeSelected
                    }
                  />
                </Grid>
              </Grid>
            </CardModuleUI>
          </Grid>
        </Grid>
        {this.state.loading.subcategories || !category[0] ? (
          <LinearProgress />
        ) : (
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Typography className={classes.title}>
                {category[0].title}
              </Typography>
              <Card className={classes.card_below}>
                <CardContent className={classes.card_content}>
                  <SubcategoriasListItem
                    category={category[0]}
                    classes={classes}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card_content: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
  list_text: {
    padding: '5px 100px 5px 15px',
  },
  list_item_title: {
    fontSize: '1rem',
    fontWeight: '500',
    marginLeft: '10px',
    marginBottom: '0px',
    padding: '0px',
  },
  title_back: {
    color: theme.texts.module_title,
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  },
  title: {
    color: theme.texts.module_title,
    fontSize: '1rem',
    margin: '20px 0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  },
  list_item: {
    padding: '5px 0px 5px 0px',
  },
  avatar: {
    marginLeft: '10px',
  },
});

const mapStateToProps = (state) => {
  return {
    preguntas: state.preguntasKnowledgeBase,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    soporteObtenerPreguntasKnowledgeBase: (callback) =>
      dispatch(soporteObtenerPreguntasKnowledgeBase(callback)),
  };
};

export const SubcategoriasList = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(SubcategoriasList_)
);
